import { isString } from "../utils/utility-functions.js";
export const AclSortMethodValues = {
    ACL_ACID_SORT_METHOD: "ACID",
    ACL_BOUNDARY_TIME_SORT_METHOD: "Boundary Time",
    ACL_CONFLICT_STATUS_SORT_METHOD: "Conflict Status",
    ACL_CONFLICT_TIME_SORT_METHOD: "Conflict Time",
    ACL_DESTINATION_SORT_METHOD: "Destination",
    ACL_SECTOR_BY_SECTOR_SORT_METHOD: "Sector-by-Sector",
};
export const DepSortMethodValues = {
    DEP_ACID_SORT_METHOD: "ACID",
    DEP_DESTINATION_SORT_METHOD: "Destination",
    DEP_ORIGIN_SORT_METHOD: "Origin",
    DEP_P_TIME_SORT_METHOD: "P-Time",
};
export const depSortFunc = (method) => (u, v) => {
    switch (method) {
        case "DEP_DESTINATION_SORT_METHOD":
            return u.destination.localeCompare(v.destination);
        case "DEP_ORIGIN_SORT_METHOD":
            return u.departure.localeCompare(v.departure);
        default:
            return u.callsign.localeCompare(v.callsign);
    }
};
export const aclSortFunc = (method) => (u, v) => {
    if (isString(u)) {
        return u.localeCompare(isString(v) ? v : v.fp.id);
    }
    if (isString(v)) {
        return u.fp.id.localeCompare(v);
    }
    let ret = 0;
    switch (method) {
        case "ACL_ACID_SORT_METHOD":
            break;
        case "ACL_DESTINATION_SORT_METHOD": {
            ret = u.fp.destination.localeCompare(v.fp.destination);
            break;
        }
        case "ACL_BOUNDARY_TIME_SORT_METHOD": {
            ret = u.entryTime && v.entryTime ? u.entryTime - v.entryTime : 0;
            break;
        }
        case "ACL_CONFLICT_STATUS_SORT_METHOD": {
            // TODO: implement
            break;
        }
        case "ACL_CONFLICT_TIME_SORT_METHOD": {
            // TODO: implement
            break;
        }
        case "ACL_SECTOR_BY_SECTOR_SORT_METHOD": {
            ret = u.ownerShort && v.ownerShort ? u.ownerShort.localeCompare(v.ownerShort) : 0;
            break;
        }
        default:
            break;
    }
    return ret !== 0 ? ret : u.fp.callsign.localeCompare(v.fp.callsign);
};
export const isAclRowField = (field) => {
    return typeof field === "string" && field.endsWith("ACL_ROW_FIELD");
};
export const isDepRowField = (field) => {
    return typeof field === "string" && field.endsWith("DEP_ROW_FIELD");
};
export const isPlanRowField = (field) => {
    return typeof field === "string" && field.endsWith("PLAN_ROW_FIELD");
};
export const isGpdField = (field) => {
    return typeof field === "string" && field.endsWith("GPD_FIELD");
};
//# sourceMappingURL=edst.js.map